'use client';
import { usePathname } from 'next/navigation';
import { createContext, PropsWithChildren } from 'react';

import { AppNavigationCtxData } from '@/types/navigation';
import { getActiveAppNavigationItem } from '@/utils/navigation';

export const AppNavigationContext = createContext<AppNavigationCtxData | null>(null);

export function AppNavigationProvider({
  children,
  appNavigationConfig,
}: PropsWithChildren<Pick<AppNavigationCtxData, 'appNavigationConfig'>>) {
  const pathname = usePathname();
  return (
    <AppNavigationContext.Provider
      value={{
        activeAppNavigationItemByRoute: getActiveAppNavigationItem(appNavigationConfig, pathname),
        appNavigationConfig,
      }}
    >
      {children}
    </AppNavigationContext.Provider>
  );
}
